import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-cream/70 py-12 border-t border-wood-dark" data-id="element-143">
      <div className="container mx-auto px-4" data-id="element-144">
        <div className="flex flex-col md:flex-row justify-between items-center max-w-6xl mx-auto" data-id="element-145">
          <div className="mb-8 md:mb-0 text-center md:text-left" data-id="element-146">
            <h4 className="text-xl font-black text-white mb-2" data-id="element-147">
              SUPER COMBO™ <span className="text-amber" data-id="element-148">PRO</span>
            </h4>
            <p className="text-sm max-w-xs" data-id="element-149">
              El sistema de muebles plegables N°1 para carpinteros emprendedores
              en Argentina.
            </p>
          </div>

          <div className="flex flex-col space-y-4 mb-8 md:mb-0" data-id="element-150">
            <a href="mailto:soportecarpinteriapro@gmail.com" className="flex items-center hover:text-amber transition-colors" data-id="element-151">
              <Mail className="w-5 h-5 mr-3" data-id="element-152" />
              soportecarpinteriapro@gmail.com
            </a>
            <a href="#" className="flex items-center hover:text-amber transition-colors" data-id="element-153">
              <Instagram className="w-5 h-5 mr-3" data-id="element-154" />
              @carpinteriaplegablepro
            </a>
            <a href="#" className="flex items-center hover:text-amber transition-colors" data-id="element-155">
              <Globe className="w-5 h-5 mr-3" data-id="element-156" />
              www.carpinteriaplegablepro.com
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-wood-dark/50 text-center text-xs text-cream/50" data-id="element-157">
          <p className="mb-2" data-id="element-158">
            © Super Combo Carpintería Plegable PRO™ 2024 — Todos los derechos
            reservados.
          </p>
          <p data-id="element-159">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}